import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  standalone: false,
  name: 'bringozTime'
})
export class BringozTimePipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {}

  transform(object: any, ref: string, defaultValue: string = '---', timeZoneId?: string): string {
    if (object && object[ref]) {
      return this.doFilter(object[ref], timeZoneId);
    } else {
      return defaultValue;
    }
  }

  private doFilter(date: any, timeZoneId: string): string {
    const format = this.splitService.getDateAndTimeConfig().time;
    if (timeZoneId) {
      return moment(date).tz(timeZoneId).format(format || 'HH:mm');
    } else {
      return moment(date).format(format || 'HH:mm');
    }
  }
}
